export const THEME_TOGGLE = 'THEME_TOGGLE'
